import { KeyboardDetectionProvider } from '@spotify-internal/encore-web';
import React from 'react';
import { useT } from '../../../features/src/i18n';
import { PageHead } from '../Layout';
import { ArtistBanner } from './ArtistBanner';
import { BlogSection } from './BlogSection';

export const Blog = () => {
  const t = useT();
  return (
    <KeyboardDetectionProvider>
      <PageHead title={[t('FRODOR_278509', 'News', '')]} />
      <ArtistBanner />
      <BlogSection />
    </KeyboardDetectionProvider>
  );
};
